import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SignedUrl } from '@monorepo/interfaces';

@Injectable({ providedIn: 'root' })
export class QuarterlyExportService {
    private readonly httpClient = inject(HttpClient);
    private readonly apiUrl = environment.apiConfig[1].uri;

    public getQuarterlyExportLink(): Observable<SignedUrl> {
        return this.httpClient.get<SignedUrl>(`${this.apiUrl}/fleet/export/quarterly/link`);
    }
}
